import { Vector3 as p } from "three";
function y(f) {
  let r;
  const o = f.map((e) => Array.isArray(e)).every((e) => e);
  o ? r = f : r = f.map((e) => e.toArray());
  const t = r[0];
  let s = 0, i = 0, c = 0, n, a, l;
  for (let e = 0, A = r.length - 1; e < r.length; A = e++)
    n = r[e], a = r[A], l = (n[0] - t[0]) * (a[2] - t[2]) - (a[0] - t[0]) * (n[2] - t[2]), s += l, i += (n[0] + a[0] - 2 * t[0]) * l, c += (n[2] + a[2] - 2 * t[2]) * l;
  l = s * 3;
  const m = [i / l + t[0], 0, c / l + t[2]];
  return o ? m : new p().fromArray(m);
}
export {
  y as getCentreOfMass
};
//# sourceMappingURL=index7.js.map
